interface UserAvatarProps {
  color1: string;
  color2: string;
  fontColor: string;
  initials: string;
}
export const UserAvatar = (props: UserAvatarProps) => {
  const { color1, color2, fontColor, initials } = props;
  return (
    <span
      className="m-avatar"
      style={{
        color: fontColor,
        backgroundImage: `linear-gradient(225deg, ${color1} 0%, ${color2} 100%)`,
      }}
    >
      {initials}
    </span>
  );
};
